"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOMIZE_ELEMENT_BUTTON_STATE = void 0;
var filter_glow_1 = require("@pixi/filter-glow");
var color_filter_1 = __importDefault(require("../utilities/color-filter"));
var filter_color_overlay_1 = require("@pixi/filter-color-overlay");
var color_1 = require("../utilities/color");
exports.CUSTOMIZE_ELEMENT_BUTTON_STATE = {
    UNDISCOVERED: "undiscovered",
    DISCOVERED: "discovered",
    UNSELECTED: "unselected",
    SELECTED: "selected"
};
var CustomizeElementButton = /** @class */ (function (_super) {
    __extends(CustomizeElementButton, _super);
    function CustomizeElementButton(action) {
        var _this = _super.call(this) || this;
        _this._action = action;
        _this.addChild(_this.sprite);
        _this.interactive = true;
        _this.on("pointerdown", function () {
            action(this);
        });
        return _this;
    }
    Object.defineProperty(CustomizeElementButton.prototype, "sprite", {
        get: function () {
            if (!this._sprite) {
                this._sprite = new PIXI.Sprite();
                this._sprite.width = 94;
                this._sprite.height = 94;
            }
            return this._sprite;
        },
        enumerable: false,
        configurable: true
    });
    CustomizeElementButton.prototype.setTexture = function (texture) {
        this.sprite.texture = texture;
    };
    CustomizeElementButton.prototype.setColor = function (color) {
        this._color = color;
        this._state = null;
    };
    CustomizeElementButton.prototype.setState = function (state) {
        if (this._state == state) {
            return;
        }
        this._state = state;
        if (state == exports.CUSTOMIZE_ELEMENT_BUTTON_STATE.UNDISCOVERED) {
            this.filters = [new filter_color_overlay_1.ColorOverlayFilter(0x000000)];
            this.alpha = 0.25;
        }
        else {
            var filters = [];
            if (state == exports.CUSTOMIZE_ELEMENT_BUTTON_STATE.DISCOVERED) {
                filters.push(new color_filter_1.default(color_1.COLOR.DARK_GREEN));
            }
            else if (this._color) {
                filters.push(new color_filter_1.default(this._color));
            }
            if (state == exports.CUSTOMIZE_ELEMENT_BUTTON_STATE.SELECTED) {
                filters.push(new filter_glow_1.GlowFilter({
                    distance: 28,
                    outerStrength: 2.6
                }));
            }
            this.filters = filters;
            this.alpha = 1;
        }
    };
    return CustomizeElementButton;
}(PIXI.Container));
exports.default = CustomizeElementButton;
